module.exports = __webpack_public_path__ + "assets/Theft.3f2ff735.svg";